<template>
  <h5 class="small-heading"><span></span>{{smallTitle}}</h5>
</template>

<script>
export default {
  name: 'SmallHeading',
  props: {
    smallTitle: String
  }
}
</script>